module.exports = __webpack_public_path__ + "img/star.68dee1b7.svg";